
export default {
  isSearching: false,
  companyList:{companies: [], total: 0},
  contractorSearchText: '',
  employerSearchText: ''
}
